import TrendingSolidSVG from "@design-system/ui-icons/vanilla/TrendingSolid"
import { createIcon } from "../createIcon"

export const TrendingSolidIcon = createIcon(TrendingSolidSVG)
